// extracted by mini-css-extract-plugin
module.exports = {"scatter_tooltip":"doc2vecresult_scatter_tooltip_3VNhi"};